import styles from "./OnSale.module.scss";
import React, {useContext, useState} from "react";
import { Card } from "react-bootstrap";
import { translateService } from "../../../services/TranslateService";
import Translate from 'react-translate-component';
import { IOnSale } from "../../../interfaces/VehicleSearch";
import { priceFormat, cx} from "../../MakeReservation/util";
import { useDispatch, useSelector } from "react-redux";
import { GlobalStore } from "../../../reduxStore";
import { DataContext } from "../../../contexts/dataContext";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {A11y, EffectFade, Navigation, Pagination, Scrollbar} from "swiper";
import 'swiper/scss'
import 'swiper/css/effect-fade'
interface IOnSaleProps{
    details: IOnSale;
    selectVehicle: Function;
}


function SaleCard ({details, selectVehicle}:IOnSaleProps) {
    const dispatch = useDispatch();
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const dataContext = useContext(DataContext)

    return <Card className="p-1">
        <span className={styles.discountPercentage}>
            {details.discountpercentage}%
        </span>
        <img width="130" height="87" className={cx(styles.carImage,styles.r24onSalesImage)} src={"https://vehicles-cdn.24rent.fi/" + details.image} alt={details.modelname.replace('&sup3','³')} loading="lazy"/>
        <div className={styles.r24LeftRightMarginAuto}>
            <div className={cx(styles.text,"font-weight-bolder")}>{details.modelname.replace('&sup3','³')}</div>
            <div className={styles.text}>{details.address}</div>
            <div className={styles.text}><Translate content={'vehicleSearch.price'} />: {priceFormat(details.price*details.discountmultiplier/100)} €</div>
        </div>
        <button onClick={()=>{
            dispatch({ type: 'SET_API_MESSAGE', payload: translateService.translate("vehicleSearch.loading") });
            apiService?.vehicle.searchWithParams({...dataContext.searchParameters,carId:details.vehicleid})
                .then(r=> {
                    if(r.vehicles[0]?.availabilityData.available)
                    {
                        selectVehicle({...r.vehicles[0], onsale: {...details}});
                    } else {
                      dispatch({type: 'SET_RESPONSE_MODAL',payload: translateService.translate("vehicleSearch1.notAvailable")})
                    }
                })
                .catch(e => { 
                    console.log(e); 
                    dispatch({type: 'SET_RESPONSE_MODAL',payload: translateService.translate('vehicleSearch.errorLoadingResults')});
                })
                .finally(() => 
                    dispatch({type: 'SET_API_MESSAGE', payload: undefined})
                );
            details.extra 
                ? dataContext.sendGaEvent('reservation', 'beginExtraOnSalesReservation', '', 0) 
                : dataContext.sendGaEvent('reservation', 'beginOnSalesReservation', '', 0);
            }}
            className='mt-1 btn-sm btn-primary text-white font-weight-bold text-uppercase'
        >
            <Translate content={'vehicleSearch.selectCar'} />
        </button>
    </Card>
}

export default function OnSale({sales, selectVehicle}: any) {
    if (!sales?.length) return null;

    return (
        <>
            <Card style={{ padding: "10px" }}>
                <Translate component='h5' className="h5 mb-3" content={'vehicleSearch.onSalesBannerText'} />
                <div style={{width:' 100%', height:'100%'}}>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={4}  // Adjust this value to control the number of slides displayed
                        pagination={false}
                        scrollbar={{ draggable: true }}
                        onSwiper={() => {}}
                        // onSlideChange={() => console.log('slide change')}
                        navigation={sales.length > 1}
                        breakpoints={{
                            // when window width is >= 100px
                            100: {
                                slidesPerView: 1,
                                spaceBetween: 5
                            },
                            // when window width is >= 320px
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 5
                            },
                            // when window width is >= 450px
                            450: {
                                slidesPerView: 3,
                                spaceBetween: 5
                            },
                            // when window width is >= 640px
                            640: {
                                slidesPerView: 4,
                                spaceBetween: 5
                            },
                            // when window width is >= 640px
                            768: {
                                slidesPerView: 5,
                                spaceBetween: 5
                            }
                        }}
                    >
                        {sales.map((details: IOnSale, index: number) => (
                            <SwiperSlide key={index}  style={{width: 'fit-content'}}>
                                <SaleCard details={details} selectVehicle={selectVehicle} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </Card>
        </>
    );
}
